import { useQuery } from 'data-fetching-client';
import { GET_ADS_PROPERTIES } from 'flow-doctor-lib/queries/AdsQueries';
const getAdsKeyPathName = filter => {
  const {
    adNetwork,
    entityType
  } = filter;
  const searchTermType = filter.searchTermType;
  const suffix = searchTermType === 'AD_TYPE' ? 'TYPE' : searchTermType;
  let parts;
  if (searchTermType === 'AD_TYPE') {
    parts = [adNetwork, 'AD', suffix];
  } else {
    parts = [adNetwork, entityType, suffix];
  }
  return parts.join('_').toLowerCase();
};
const useAdsFilterProperties = ({
  portalId,
  filter
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ADS_PROPERTIES, {
    variables: {
      portalId
    }
  });
  const dataToReturn = data ? data.adsProperties.find(adProperty => adProperty.name === getAdsKeyPathName(filter)) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useAdsFilterProperties;